import {
  filterMenuByPermissions
} from "@src/security/permissions";

const MENU = {
  oniRecords: {
    label:
      "app.menu.cep_records.label",

    description:
      "app.menu.cep_records.description",

    path:
      "/person",

    requires: [
      "READ_PERSON"
    ],


    options: {
      list: {
        label:
          "app.menu.actions.list",

        path:
          "/person"
      }
    }
  },

  voterRegistration: {
    label:
      "menu.voter.registration",

    description:
      "menu.voter.registration.description",

    options: {
      applications: {
        label:
          "menu.voter.applications",

        path:
          "/voter-application",

        requires: [
          "SEARCH_VOTER_APPLICATION",
          "COUNT_VOTER_APPLICATION"
        ]
      },

      records: {
        label:
          "menu.voter.records",

        path:
          "/voter",

        requires: [
          "SEARCH_VOTER",
          "COUNT_VOTER"
        ]
      },

      preliminaryRolls: {
        label:
          "voterRoll.preliminaryRolls",

        path:
          "/voter-roll/preliminary",

        requires: [
          "SEARCH_VOTER_ROLL",
          "COUNT_VOTER_ROLL"
        ]
      },

      finalRolls: {
        label:
          "voterRoll.finalRolls",

        path:
          "/voter-roll/final",

        requires: [
          "SEARCH_VOTER_ROLL",
          "COUNT_VOTER_ROLL"
        ]
      }
    }
  },

  fieldOperators: {
    label:
      "app.menu.field_operators.label",

    description:
      "app.menu.field_operators.description",

    path:
      "/user-account-request",

    options: {
      accountRequests: {
        label:
          "app.menu.user_account_requests.label",

        path:
          "/user-account-request",

        requires: [
          "READ_USER_ACCOUNT_REQUEST"
        ]
      },

      accounts: {
        label:
          "app.menu.user_accounts.label",

        path:
          "/user-account",

        requires: [
          "READ_USER_ACCOUNT"
        ]
      }
    }
  },

  electoralGeography: {
    label:
      "app.menu.electoral_geography.label",

    description:
      "app.menu.electoral_geography.description",

    path:
      "/electoral-geography",

    requiresAny: [
      "CREATE_DEPARTMENT",
      "UPDATE_DEPARTMENT",

      "CREATE_ARRONDISSEMENT",
      "UPDATE_ARRONDISSEMENT",

      "CREATE_COMMUNE",
      "UPDATE_COMMUNE",

      "CREATE_SECTION",
      "UPDATE_SECTION",

      "CREATE_CONSTITUENCY",
      "UPDATE_CONSTITUENCY",

      "CREATE_VOTING_CENTER",
      "UPDATE_VOTING_CENTER"
    ],

    options: {
      manage: {
        label:
          "app.menu.actions.manage",

        path:
          "/electoral-geography"
      }
    }
  },


  diagnostics: {
    label:
      "menu.diagnostics.label",

    description:
      "menu.diagnostics.description",

    path:
      "/diagnostics",

    requires: [
      "READ_DIAGNOSTICS",
      "COUNT_DIAGNOSTICS"
    ],

    options: {
      list: {
        label:
          "app.menu.actions.list",

        path:
          "/diagnostics"
      }
    }
  },

reporting: {
  label:
    "app.menu.reporting.label",

  description:
    "app.menu.reporting.description",

  path:
    "/reporting",

  requiresAny: [
    "READ_STATISTICAL_REPORTS",
    "READ_OPERATIONAL_REPORTS"
  ],

  options: {
    overview: {
      label:
        "app.menu.reporting.overview",

      path:
        "/reporting",

      requires: [
        "READ_STATISTICAL_REPORTS"
      ]
    },

    advanced: {
      label:
        "app.menu.reporting.advanced",

      path:
        "/reporting/advanced",

      requires: [
        "READ_STATISTICAL_REPORTS"
      ]
    },

    tablets: {
      label:
        "menu.reporting.tablets",

      path:
        "/reporting/tablets",

      requires: [
        "READ_OPERATIONAL_REPORTS"
      ]
    },

    votingCenters: {
      label:
        "app.menu.reporting.votingCenterReports",

      path:
        "/reporting/voting-centers",

      requires: [
        "READ_OPERATIONAL_REPORTS"
      ]
    }
  }
},


  developer: {
    label: "app.menu.developer.label",
    path: "/developer/api",
    requires: [
      "READ_API_DOCUMENTATION"
    ],
    options: {
      apiDocumentation: {
        label: "app.menu.developer.apiDocumentation",
        path: "/developer/api",
        requires: [
          "READ_API_DOCUMENTATION"
        ]
      }
    }
  },

  qalaaUsers: {
    label:
      "menu.users.label",

    description:
      "menu.users.description",

    path:
      "/__qalaa-user",

    requiresAny: [
      "SEARCH_QALAA_USER",
      "COUNT_QALAA_USER",
      "READ_QALAA_USER",
      "SEARCH_API_USERS",
      "COUNT_API_USERS",
      "READ_API_USERS"
    ],

    options: {
      list: {
        label:
          "menu.backoffice",

        path:
          "/__qalaa-user",

        requires: [
          "SEARCH_QALAA_USER",
          "COUNT_QALAA_USER"
        ]
      },

      apiUsers: {
        label:
          "menu.api_users",

        path:
          "/__api-users",

        requires: [
          "SEARCH_API_USERS",
          "COUNT_API_USERS"
        ]
      }
    }
  }
};

export const menu = (
  session
) => {
  const filtered =
    filterMenuByPermissions(
      MENU,
      session
    );

  const {
    fieldOperators,
    qalaaUsers
  } = filtered;

  /*
   * If the user has access to the regular Users menu,
   * nest Field operators underneath it.
   *
   * If the user only has field-operator permissions,
   * leave Field operators as its own top-level menu.
   */
  if (
    !fieldOperators ||
    !qalaaUsers
  ) {
    return filtered;
  }

  const {
    fieldOperators: _fieldOperators,
    ...rest
  } = filtered;

  return {
    ...rest,

    qalaaUsers: {
      ...qalaaUsers,

      options: {
        ...qalaaUsers.options,

        fieldOperators
      }
    }
  };
};

export default menu;